module.exports = __webpack_public_path__ + "img/feature_2.4c89bbff.jpg";